<script>
import { pushDataLayer } from '@Foundation';

export default {
  name: 'BvScrollTagging',
  props: {
    taggingData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      isScrolledContent: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
    this.startBvReadyCheck();
    console.log("BV.SCROLL.Tagging...");
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.bvReadyInterval) {
      clearInterval(this.bvReadyInterval);
    }
  },
  methods: {
    onScroll() {
      this.checkAndSendTagging();
    },
    isPartiallyInViewport(element) {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;

      return (
        rect.top < windowHeight &&
        rect.bottom > 0 &&
        rect.left < windowWidth &&
        rect.right > 0
      );
    },
    checkAndSendTagging() {
      if (this.isScrolledContent) {
        return;
      }

      const bvWrapper = document.querySelector(".bvReviews__wrapper div[data-bv-show='reviews']");
      if (bvWrapper && bvWrapper.shadowRoot) {
        const bvReviewsV2 = bvWrapper.shadowRoot.getElementById('reviews_container');
        if (bvReviewsV2 && bvReviewsV2.hasChildNodes() && this.isPartiallyInViewport(bvReviewsV2)) {
            this.sendTaggingData();
        }
      }
    },
    startBvReadyCheck() {
      this.bvReadyInterval = setInterval(() => {
        if (this.isScrolledContent) {
          clearInterval(this.bvReadyInterval);
          return;
        }

        const bvWrapper = document.querySelector(".bvReviews__wrapper div[data-bv-show='reviews']");
        if (bvWrapper && bvWrapper.shadowRoot) {
          const bvReviewsV2 = bvWrapper.shadowRoot.getElementById('reviews_container');
          if (bvReviewsV2 && bvReviewsV2.hasChildNodes()) {
            clearInterval(this.bvReadyInterval);
            this.checkAndSendTagging();
          }
        }
      }, 500);
    },
    sendTaggingData() {
      if (this.isScrolledContent) {
        return;
      }

      this.isScrolledContent = true;
      window.removeEventListener('scroll', this.onScroll);
      if (this.bvReadyInterval) {
        clearInterval(this.bvReadyInterval);
      }
      const isTaggingDataExist = !!Object.keys(this.taggingData).length;
      isTaggingDataExist && pushDataLayer(this.taggingData);
    },
  },
};
</script>